import { VTMusic } from '../../assets/icons';

export const virtualTourMusicOptions = [
	{
		filename: 'By My Side',
		originalUrl: VTMusic.byMySide
	},
	{
		filename: 'Teenage Dream',
		originalUrl: VTMusic.teenageDream
	},
	{
		filename: 'Time to Move',
		originalUrl: VTMusic.timeToMove
	},
	{
		filename: 'Time Off',
		originalUrl: VTMusic.timeOff
	},
	{
		filename: 'Almanac',
		originalUrl: VTMusic.almanac
	},
	{
		filename: 'Tech No Ledge',
		originalUrl: VTMusic.techNoLedge
	},
	{
		filename: 'Music for the Soul Instrumental',
		originalUrl: VTMusic.musicForTheSoul
	},
	{
		filename: 'All Stars',
		originalUrl: VTMusic.allStars
	},
	{
		filename: 'Subjection',
		originalUrl: VTMusic.subjection
	},
	{
		filename: 'A Big Adventure',
		originalUrl: VTMusic.aBigAdventure
	},
	{
		filename: 'Binary Love',
		originalUrl: VTMusic.binaryLove
	},
	{
		filename: 'In Viaggio Versol Alba',
		originalUrl: VTMusic.inViaggioVersolAlba
	},
	{
		filename: 'Five to One',
		originalUrl: VTMusic.fivetoOne
	},
	{
		filename: 'High Line',
		originalUrl: VTMusic.highLine
	}
];
